import React, { forwardRef } from 'react';

import { type XCSS, xcss } from '@atlaskit/primitives';

import { TH, type THProps } from '../../ui/primitives/th';
import { TableType } from '../charlie-table';

const InputHeadStyle = xcss({
	borderBlock: '1px solid',
	borderInlineEnd: '1px solid',
	borderColor: 'color.border',
	backgroundColor: 'elevation.surface.sunken',
});

const InventoryHeadStyle = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':last-of-type': {
		borderInlineEnd: '1px solid',
		borderColor: 'color.border',
	},
	backgroundColor: 'elevation.surface',
	height: '48px',
	borderBlockStart: '1px solid',
	borderBlockEnd: '2px solid',
	borderColor: 'color.border',
});

const HeadCellStyle = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':first-of-type': {
		borderInlineStart: '1px solid',
		borderColor: 'color.border',
		borderTopLeftRadius: '7px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':last-of-type': {
		paddingInline: 'space.100',
		borderColor: 'color.border',
		borderTopRightRadius: '7px',
	},
	position: 'sticky',
	borderColor: 'color.border',
	whiteSpace: 'nowrap',
	verticalAlign: 'middle',
	color: 'color.text.subtlest',
	textAlign: 'left',
	top: 'space.0',
	// @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 2
	zIndex: 2,
	paddingInline: 'space.100',
});

export type HeadCellProps = {
	tableType?: TableType;
} & THProps;

/**
 * __HeadCell__
 *
 * HeadCell element. A styled `th` element.
 */
export const HeadCell = forwardRef<HTMLTableCellElement, HeadCellProps>(
	(
		{
			children,
			align,
			testId,
			backgroundColor,
			xcss: customXcss,
			scope = 'col',
			tableType = TableType.input,
			...props
		},
		ref,
	) => {
		return (
			<TH
				{...props}
				scope={scope}
				align={align}
				testId={testId}
				ref={ref}
				xcss={[
					HeadCellStyle,
					tableType === TableType.inventory && InventoryHeadStyle,
					tableType === TableType.input && InputHeadStyle,
					// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
					customXcss as XCSS,
				]}
				backgroundColor={backgroundColor}
			>
				{children}
			</TH>
		);
	},
);
